import { MenuItem, Select, Stack } from "@mui/material";
import { I18N_NAMESPACES, SUPPORTED_LOCALES } from "@src/appV2/i18n/constants";
import { useTranslationSettings } from "@src/appV2/i18n/settings/useTranslationSettings";
import type { SupportedLocale } from "@src/appV2/i18n/types";
import { useTu } from "@src/appV2/i18n/useTu";
import { SettingRow } from "@src/appV2/redesign/components/SettingRow";

export function TranslationSectionView() {
  const { settings, setLocale } = useTranslationSettings();
  const { tu } = useTu(I18N_NAMESPACES.settings);

  function handleLocaleChange(value: string) {
    if (isSupportedLocale(value)) {
      setLocale(value);
    }
  }

  return (
    <Stack>
      <SettingRow
        action={
          <Select
            inputProps={{ "aria-label": tu("Language") }}
            size="small"
            value={settings.locale}
            sx={{ minWidth: 180 }}
            onChange={(event) => {
              handleLocaleChange(event.target.value);
            }}
          >
            <MenuItem value={SUPPORTED_LOCALES.enUs}>{tu("English")}</MenuItem>
            <MenuItem value={SUPPORTED_LOCALES.es419}>{tu("Spanish")}</MenuItem>
          </Select>
        }
        subtitle={tu("Choose your preferred language for the redesigned pages.")}
        title={tu("Language")}
      />
    </Stack>
  );
}

function isSupportedLocale(value: string): value is SupportedLocale {
  return value === SUPPORTED_LOCALES.enUs || value === SUPPORTED_LOCALES.es419;
}
